import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Services.
import { AuthGuardService } from './service/managers/auth-guard.service';
import { PermissionGuardService } from './service/managers/permission-guard.service';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { PermissionsComponent } from './user_defined/components/permissions/permissions.component';
import { CreateRolesComponent } from './user_defined/components/create-roles/create-roles.component';
import { RolesComponent } from './user_defined/components/roles/roles.component';
import { EditRolesComponent } from './user_defined/components/edit-roles/edit-roles.component';
import { UsersHomeComponent } from './user_defined/components/users-home/users-home.component';
import { UsersProfileComponent } from './user_defined/components/users-profile/users-profile.component';
import { LoginComponent } from './user_defined/components/login/login.component';
import { MessagesComposeComponent } from './user_defined/shared/messages-compose/messages-compose.component';
import { MessagesComponent } from './user_defined/components/messages/messages.component';
import { ContactsComponent } from './user_defined/components/contacts/contacts.component';
import { ContactsHomeComponent } from './user_defined/shared/contacts-home/contacts-home.component';
import { ContactsGroupsComponent } from './user_defined/shared/contacts-groups/contacts-groups.component';
import { PermissionsProfileComponent } from './user_defined/shared/permissions-profile/permissions-profile.component';
import { HomeComponent } from './user_defined/components/home/home.component';
import { MessagesAllComponent } from './user_defined/shared/messages-all/messages-all.component';
import { MessagesConversationComponent } from './user_defined/shared/messages-conversation/messages-conversation.component';
import { GroupsHomeComponent } from './user_defined/shared/groups-home/groups-home.component';

//Voice Routes
import { VoiceBatchComponent } from './modules/voice/voice-batch/voice-batch.component';
import { VoiceDetailComponent } from './modules/voice/voice-detail/voice-detail.component';
import { VoiceReportsComponent } from './modules/voice/voice-reports/voice-reports.component';

//Email Routes
//import { UnfullfilledComponent } from './modules/email/unfullfilled/unfullfilled.component';
//import { DwkComponent } from './modules/email/dwk/dwk.component';
//import { PartnerSegmentComponent } from './modules/email/partner-segment/partner-segment.component';
//import { EmailScheduleComponent } from './modules/email/email-schedule/email-schedule.component';

//SMS
import { MergeTemplateComponent } from './modules/sms/merge-template/merge-template.component'

//Lazarus
import { ReportsComponent } from './modules/joytogive/reports/reports.component'
import { MaintenanceComponent } from './modules/lazarus/maintenance/maintenance.component';
import { TablemakerComponent } from './modules/lazarus/tablemaker/tablemaker.component' ;

//JoyToGive
import { ItemComponent } from './modules/joytogive/item/item.component'
import { ItemMilestoneComponent } from './modules/joytogive/item-milestone/item-milestone.component'
import { WebsiteComponent } from './modules/joytogive/website/website.component'
import { UtmComponent } from './modules/joytogive/utm/utm.component'
import { CommentComponent } from './modules/joytogive/comment/comment.component'



export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'joytogive',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'reports',
        component: ReportsComponent,
      },
      {
        path: 'maintenance',
        component: MaintenanceComponent,
      },
      {
        path: 'tablemaker',
        component: TablemakerComponent,
      },
      {
        path: 'item-inventory',
        component: ItemComponent,
      },
      {
        path: 'item-milestone',
        component: ItemMilestoneComponent,
      },
      {
        path: 'website',
        component: WebsiteComponent,
      },
      {
        path: 'utm',
        component: UtmComponent,
      },
      {
        path: 'comment',
        component: CommentComponent,
      },
      {
        path: 'permissions',
        component: PermissionsComponent,
        canActivate: [PermissionGuardService],
        data: {
          permissions: ['view-permission'],
          operation: 'allowAny',
        }
      },
      // {
      //   path: 'permissions',
      //   component: PermissionsComponent,
      // },
      // {
      //   path: 'email_schedule',
      //   component: EmailScheduleComponent
      // },
      {
        path: 'permissions_create',
        component: PermissionsProfileComponent
      },      
      {
        path: 'roles',
        component: RolesComponent,
      },
      {
        path: 'create_role',
        component: CreateRolesComponent
      },
      {
        path: 'edit_role/:id',
        component: EditRolesComponent
      },
      {
        path: 'users_home',
        component: UsersHomeComponent
      },
      {
        path: 'user_create',
        component: UsersProfileComponent
      },
      {
        path: 'user_profile/:id',
        component: UsersProfileComponent,
      },
      {
        path: 'messages',
        component: MessagesComponent,
        children: [
          {
            path: '',
            redirectTo: 'all',
            pathMatch: 'full',
          },
          {
            path: 'compose',
            component: MessagesComposeComponent,
          },
          {
            path: 'all',
            component: MessagesAllComponent,
          },
          {
            path: 'all/:id',
            component: MessagesAllComponent,
          },
          {
            path: 'unread',
            component: MessagesAllComponent,
          },
          {
            path: 'unread/:id',
            component: MessagesAllComponent,
          },
          {
            path: 'sent',
            component: MessagesAllComponent,
          },
          {
            path: 'sent/:id',
            component: MessagesAllComponent,
          },
          {
            path: 'allconversation',
            component: MessagesAllComponent,
          },
          {
            path: 'allconversation/:id',
            component: MessagesAllComponent,
          },
          {
            path: 'conversation/:cv_id',
            component: MessagesConversationComponent,
          }
        ],
      },
      {
        path: 'contacts',
        component: ContactsComponent,
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },
          {
            path: 'home',
            component: ContactsHomeComponent
          },
          {
            path: 'groups',
            children: [
              {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
              },
              {
                path: 'home',
                component: GroupsHomeComponent,
              }
            ]
          },
        ],
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/joytogive',
    pathMatch: 'full',
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
